import axios from "axios";

export const setOnboardingTypeDone = async (id) => {
    return axios.post(route('onboarding.set-done', { id }));
}
